import { useTranslation } from 'react-i18next';
import { useRef, useEffect } from 'react';

const Noticias = ({ noticias, ruta, config, lang }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    const swiperRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    useEffect(() => {
        const swiper = swiperRef.current;
        if (!swiper) return;

        const handleMouseDown = (e) => {
            isDragging.current = true;
            startX.current = e.pageX - swiper.offsetLeft;
            scrollLeft.current = swiper.scrollLeft;
            swiper.style.cursor = 'grabbing';

            // Prevenir selección de texto
            swiper.style.userSelect = 'none';
        };

        const handleMouseLeave = () => {
            if (isDragging.current) {
                isDragging.current = false;
                swiper.style.cursor = 'grab';
            }
        };

        const handleMouseUp = () => {
            isDragging.current = false;
            swiper.style.cursor = 'grab';
            swiper.style.userSelect = '';

        };

        const handleMouseMove = (e) => {
            if (!isDragging.current) return;
            e.preventDefault();
            const x = e.pageX - swiper.offsetLeft;
            const walk = (x - startX.current) * 2; // Velocidad del scroll
            swiper.scrollLeft = scrollLeft.current - walk;

        };

        swiper.addEventListener('mousedown', handleMouseDown);
        swiper.addEventListener('mouseleave', handleMouseLeave);
        swiper.addEventListener('mouseup', handleMouseUp);
        swiper.addEventListener('mousemove', handleMouseMove);

        // Cambiar cursor al hover
        swiper.style.cursor = 'grab';

        return () => {
            swiper.removeEventListener('mousedown', handleMouseDown);
            swiper.removeEventListener('mouseleave', handleMouseLeave);
            swiper.removeEventListener('mouseup', handleMouseUp);
            swiper.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return (
        <>
            <h2 className="text-center">{t("Reserva de forma directa en Vale Suites")}</h2>

            <div className="overflow-swiper">
                <div className="cc-offer-swiper centered" style={{ display: "flex", overflowX: "auto", scrollBehavior: "smooth", scrollbarWidth: "none", msOverflowStyle: "none", WebkitOverflowScrolling: "touch" }} ref={swiperRef}>

                    <style jsx="true">
                        {`
                                .cc-offer-swiper::-webkit-scrollbar {
                                    display: none;
                                }
                            `}
                    </style>
                    {noticias.map((unanoticia, index) => (
                        <div className="c-card c-card-oferta" style={{ marginRight: "16px", flexShrink: 0 }} role="group" aria-label={`${index}/${noticias.length}`} key={unanoticia.id || index}>
                            <div className="position-relative">
                                <figure className="c-card_img">
                                    {
                                        unanoticia.imagen != ""
                                            ? <img className="img" src={`${ruta}/blog/${unanoticia.id}/${unanoticia.imagen}`} alt={unanoticia.eltitulo} />
                                            : <img className="img" src="/images/web/bedloop-nofoto.png" alt={unanoticia.eltitulo} />
                                    }
                                </figure>
                                <div className="c-card-oferta_text">
                                    <p className="nolineheight">

                                        <strong>{unanoticia.eltitulo}</strong>

                                    </p>
                                </div>
                            </div>
                            <button tabIndex="0" className="btn btn-link"> {t("Ver detalles")} <div className="o-icon arrow">
                                <i className="fa-solid fa-arrow-right"></i>
                            </div>
                            </button>
                        </div>
                    ))}
                </div >
            </div >
            <div className="container">
                <a className="mx-auto mt-5 btn btn-primary d-flex w-xs-fit btn-xs-full justify-content-center" href={`/${preidioma}${t("blog")}`}> {t("Más noticias")} </a>
            </div>
        </>
    );
}

export default Noticias;
